module.exports = __webpack_public_path__ + "static/media/alt_seller_header.997b80d7.png";